import { useEffect, useMemo } from "react";
import { UploadFile } from "@coworker/apprestructured/src/task-management/services/uploads.service";
import {
  isLoading,
  LOADING,
  Loading,
} from "@coworker/apprestructured/src/task-management/loading";

export type UploadImageUrl = {
  uploadId: string;
  // null means the file failed to fetch
  url: string | null | Loading;
};

/**
 * Handles creating and revoking object urls for uploaded images.
 */
export function useUploadImageUrls(uploadFiles: UploadFile[] | Loading) {
  const uploadImageUrls = useMemo<UploadImageUrl[] | Loading>(() => {
    if (isLoading(uploadFiles)) {
      return LOADING;
    } else {
      return uploadFiles.map(({ uploadId, blob }) => {
        if (blob === null) {
          return { uploadId, url: null };
        } else if (isLoading(blob)) {
          return { uploadId, url: LOADING };
        } else {
          return { uploadId, url: URL.createObjectURL(blob) };
        }
      });
    }
  }, [uploadFiles]);

  // Revoke the object urls when they are no longer used
  useEffect(() => {
    return () => {
      if (!isLoading(uploadImageUrls)) {
        uploadImageUrls.forEach(({ url }) => {
          if (url !== null && !isLoading(url)) {
            URL.revokeObjectURL(url);
          }
        });
      }
    };
  }, [uploadImageUrls]);

  return uploadImageUrls;
}
